import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import { HttpService } from '../shared/http.service';
declare let $: any;
import { DomSanitizer } from '@angular/platform-browser';
import {AppComponent} from "../app.component";

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    let val = value || '';
    return this.sanitized.bypassSecurityTrustHtml(val);
  }

}
@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')]
})
export class HomeComponent implements OnInit {
  private quality: Array<object>;
  private news: Array<object>;
  doctors: object;
  interval: any;
  dataCount: number;
  constructor(private http: HttpService, private app: AppComponent) {
    this.doctors = {};
    this.news = [];
    this.dataCount = 0;
    this.app.setPreloader(true);
    this.app.newsData.subscribe(e => {
      this.news = e['data'] || [];
      console.log(this.news);
      this.readyNews(true);
    });
  }

  ngOnInit() {
    this.getDoctors();
    this.quality = [
      {
        icon: 'icon-doctor',
       title: 'Профессионализм',
       desc:  'Высокий профессионализм специалистов\n' +
       '      с высшим медицинским образованием'
      },
      {
        icon: 'icon-lab',
        title: 'Оборудование',
       desc:  'Современное оборудование'
      },
      {
        icon: 'icon-safe',
        title: 'Безопасность',
       desc:  'Стерилизация инструментов ' +
       'и кабинетов оборудованием нового поколения'
      },
      {
        icon: 'icon-currency',
        title: 'Экономия времени',
       desc:  'Лечение, диагностика, ' +
       'консультации смежных специалистов'
      },
      {
        icon: 'icon-lock2',
        title: 'Конфиденциальность',
        desc:  ''
      },
      {
        icon: 'icon-strategy',
        title: 'Подход',
        desc:  'Персональный подход к каждому клиенту'
      },
      {
        icon: 'icon-icons170',
        title: 'Цены',
       desc:  'Доступные цены'
      },
      {
        icon: 'icon-users',
        title: 'Комфорт',
       desc:  'Комфорт, высокий уровень сервиса'
      },
      {
        icon: 'icon-ecg-line',
        title: 'Стабильность',
       desc:  'Стабильность, постоянство качества'
      },
      {
        icon: 'icon-shield2',
        title: 'Гарантия',
       desc:  'Гарантия и надежность'
      }
    ]
    this.news = this.app.news;
    this.dataCount += this.news.length > 0 ? 1 : 0;
  }

  ready(isReady: boolean) {
    if (isReady) {
      let self = this;
      this.interval = setInterval(function () {
        if ($("#carousel-anything-1")){
          clearInterval(self.interval);
          $("#carousel-anything-1").owlCarousel({
            items :3,
            lazyLoad : true,
            navigation : true,
            navigationText: ["<span class='custom-owl-icons icon-chevron-thin-left'></span>","<span class='custom-owl-icons icon-chevron-thin-right'></span>"],
            loop: true
          });
        }
      }, 100)
    }
  }

  readyNews(isReady: boolean) {
    if (isReady) {
      this.app.activateRevo();
      this.setPreloader();
    }
  }

  removeP(val) {
    if (val) {
      let elem = document.createElement('div');
      elem.innerHTML = val;
      return elem.querySelectorAll('p')[0] ? elem.querySelectorAll('p')[0].innerHTML : val;
    }
  }

  setPreloader() {
    this.dataCount++;
    // let self = this;
    if (this.dataCount == 2) {
      // setTimeout(function () {
        this.app.setPreloader(false)
      // },500);
    }
  }

  getDoctors(){
    let url = '?json=get_page&page_id=28';
    this.http.get(url).subscribe(
      data => {
        // Emit list event
        this.setPreloader();
        this.doctors = data['page'];
        this.ready(true);
      },
      err => {
        this.setPreloader();
        // Log errors if any
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/home/home.component.ts